<template>
	<div>
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getUsersUrl" @listData='getDeviceData' ></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>

		<resetPasswordModal  ref="ResetPasswordModal"></resetPasswordModal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi';
	import searchForm from './Template/UserForm.vue';
	import infoModal from './Template/UserModal.vue';
	import resetPasswordModal from './Template/ResetPassword.vue';
	import { formatLocalTime } from "../../../utils/date"

	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			infoModal,
			resetPasswordModal
			// DistributeModal
		},
		data() {
			return {
				getUsersUrl: webapi.base_api_url + '/System/GetUsers',
				//Query Component Parameters
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: [this.$t('Top.privilegeManage'), '>>',this.$t('userManage')],
				childOperatorList: [],
				//Table Title Data
				columns1: [
					// {
					// 	title: 'ID',
					// 	key: 'Id',
					// 	width: 100
					// }, 
					{
						title: this.$t('UserManagement.UserAccount'),
						key: 'Name',
					},
					{
						title: this.$t('UserManagement.UserName'),
						key: 'DisplayName',
					},
					{
						title: this.$t('Common.Role'),
						key: 'RoleId',
						render: (h, params) => {
							return h('div', params.row.RoleName)
						}
					},
					{
						title:this.$t('Common.Status'),
						key: 'Status',
						render: (h, params) => {
							var status = params.row.Status;
							var statusText=this.$t('UserManagement.Normal');
							if(status != '0')
							    statusText= this.$t('UserManagement.Lock');
							return h('div', statusText)
						}
					},
					{
						title: this.$t('Common.Operator'),
						key: 'OperatorName',
					},
					
					{
						title: this.$t('Common.CreateTime'),
						key: 'CreateTime',
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.CreateTime))
						}
					},
					
					{
						title: this.$t('Common.Actions'),
						key: 'action',
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up', params.row)
										}
									}
								}, this.$t('Common.Edit')) : h(),

								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('resetpassword', params.row)
										}
									}
								}, this.$t('Common.ResetPassword')) : h(),
								
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//To avoid incorrect operations, confirm and cancel should function oppositely.
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: this.$t('Common.Cancel'),
													cancelText: this.$t('Common.Confirm'),
													onCancel: () => {
														this.otherMethodStation(name,
															params.row.Id);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$t('Common.OtherActions')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
											item) => { 
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h(),
							]);
						}
					}
				],
				data: [],
				methodList: [{
					Id: 0,
					name: 'unlock',
					Status: this.$t('UserManagement.Normal')
				}, {
					Id: 9,
					name: 'lock',
					Status: this.$t('UserManagement.Lock')
				}, ]
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//Except for delete and modify operations
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).Id
				this.$axios.post(webapi.base_api_url + "/System/SetUserStatus", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success(name + this.$t('Common.AddSuccess'));
						this.handleSubmit();
					}
				})
			},
			/**Component Fixing Method**/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'add':
						this.$refs.ItemModal.show(type, params)
						break;
				
					case 'resetpassword':
						console.log(params);
						this.$refs.ResetPasswordModal.show(type, params)
					
					break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			getChildOperatorList: function () {
				this.$axios.post(webapi.base_api_url + '/System/GetChildOperatorList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.childOperatorList = res.data.Data.List
					}
				})
			}
		},
	}
</script>

<style>
</style>
